"use client"

import { signOut } from "next-auth/react"
import React from "react"

import IconLogout from "./icons/IconLogout"

type Props = {
  label: string
}

const LogoutButton = ({ label }: Props) => {
  const [isLoggingOut, setIsLoggingOut] = React.useState(false)

  return (
    <button
      type="button"
      tabIndex={0}
      disabled={isLoggingOut}
      className="text-sm text-purple inline-flex items-center gap-1 font-bold hover:text-purple-500 hover:underline disabled:opacity-60 disabled:cursor-not-allowed"
      onClick={async (e) => {
        e.preventDefault()
        if (isLoggingOut) return
        setIsLoggingOut(true)
        // Use full URL for logout redirect to ensure it works with proxy
        const isLocalProxy =
          typeof window !== "undefined" &&
          window.location.pathname.startsWith("/minasidor")
        const callbackUrl = isLocalProxy
          ? `${window.location.origin}/minasidor/`
          : "/"
        await signOut({ callbackUrl })
      }}>
      <IconLogout className="w-5 h-5" />
      <span className="mt-1 ml-1">{isLoggingOut ? "Loggar ut" : label}</span>
    </button>
  )
}

export default LogoutButton
